import { compose, withProps, lifecycle } from 'recompose'
import { withRouter, RouteComponentProps } from 'react-router-dom'

type RootPath = {
  rootPath: string
}

const withRootPath = compose<any, any>(
  withRouter,
  withProps<RootPath, RouteComponentProps>(({ location }) => ({
    rootPath: '/' + location.pathname.split('/')[1],
  })),
)

const withShouldUpdate = compose<any, any>(
  withRootPath,
  lifecycle<any, {}>({
    shouldComponentUpdate(nextProps = {} as any) {
      const { props } = this

      return (
        nextProps.rootPath !== props.rootPath ||
        Boolean(nextProps.location.state && nextProps.location.state.search) ||
        nextProps.apps !== props.apps
      )
    },
  }),
)

export { withShouldUpdate, withRootPath }
